interface Date {
    toDateTime(showTime?: boolean): string;
}


Date.prototype.toDateTime = function (this: Date, showTime?: boolean): string {
    if (!this)
        return "-"

    const options: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "long",
        day: "numeric"
    }

    if (showTime) {
        options.hour = "2-digit"
        options.minute = "2-digit"
        options.hour12 = true
    }

    return this.toLocaleDateString("en-US", options)
}